// extracted by mini-css-extract-plugin
export default {"container":"company_container__ka+ij","TabsContent":"company_TabsContent__W7XDU","RowTabs":"company_RowTabs__aM8ik"};